import { ComponentType } from '@angular/cdk/portal';
import { Component, Input, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CustomSidePanelDialogInterface } from 'src/app/core/interfaces/components/custom-side-panel-dialog.interface';

@Component({
    selector: 'app-custom-side-panel',
    templateUrl: './custom-side-panel.component.html',
    styleUrls: ['./custom-side-panel.component.scss'],
    standalone: false
})
export class CustomSidePanelComponent implements OnInit{
  @Input() loading: boolean;
  @Input() dialogRef: MatDialogRef<ComponentType<CustomSidePanelDialogInterface>>;



  ngOnInit(): void {
    // check if dialog is the content library and add drawer slide in css class
    setInterval(() => {
      let contentLibDialog = document.querySelector('.custom-side-panel-dialog');
      if (contentLibDialog) {
          contentLibDialog.classList.add('dialog-drawer');
      }
    }, 50);

  }

  closeDialog(): void {
    this.dialogRef.close();

  }
}
